import * as yup from 'yup';

const reqSiNo = yup
  .boolean()
  .oneOf([true, false], 'Seleccione una opción')
  .nonNullable('Seleccione una opción')
  .typeError('Seleccione una opción');

export const cklSomnolenciaSchema = yup.object({
  conductor: yup.string().trim().required('Requerido'),
  patente: yup
    .string()
    .required("La patente es obligatoria")
    .test("patenteValida", "Debe seleccionar una patente registrada", function (val) {
      const { vehiculos = [] } = this.options.context || {};
      const patente = String(val || "").toUpperCase().trim();
      return vehiculos.some(v => v.patente.toUpperCase() === patente);
    }),
  // Sección I
  durmioBien: reqSiNo,
  medicacion: reqSiNo,
  medDetalle: yup
    .string()
    .trim()
    .when('medicacion', {
      is: true,
      // then: (s) => s.required('Indique la medicación'),
      then: (s) =>
        s
          .required('Indique la medicación')
          .matches(
            /^[A-Za-zÁÉÍÓÚáéíóúÑñÜü\s]+$/,
            'Solo se permiten letras y espacios (sin números ni símbolos)'
          ),
      otherwise: (s) => s.notRequired(),
    }),
  actividadExigente: reqSiNo,
  resfriado: reqSiNo,
  comidasCopiosas: reqSiNo,

  // Sección II
  sintomas: yup.object({
    dificultadConcentrarse: reqSiNo,
    movimientosLentos: reqSiNo,
    visionBorroza: reqSiNo,
    desorientacion: reqSiNo,
    trayectoriaRecta: reqSiNo,
    bostezos: reqSiNo,
    parpadosPesados: reqSiNo,
    cabeceos: reqSiNo,
    dolorCabeza: reqSiNo,
    mareos: reqSiNo,
    dolorNucaEspalda: reqSiNo,
    cambiosPostura: reqSiNo,
  }),

  // Consentimiento: debe ser true
  consentimiento: yup
    .boolean()
    .oneOf([true], 'Debes aceptar la declaración para continuar')
});